import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import JoditEditor from "jodit-react";
import { connect } from "react-redux";

function SliderAddUpdate({ onlyPermission }) {

    const { fetchRequest, validateImageRatio, globalImageUplaodAPI } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/slider/edit`
    const storeApi = `${baseURL}/admin/slider/store`
    const imageApi = globalImageUplaodAPI()
    const updateApi = `${baseURL}/admin/slider/update`
    const compressImageApi = `${baseURL}/admin/compress_image`


    const navigate = useNavigate()
    const { id } = useParams()
    const location = useLocation()
    const combinedRef = useRef({});
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({});
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
    })
    const [darkImageFile, setDarkImageFile] = useState('');
    const [lightImageFile, setLightImageFile] = useState('');
    const [adsBannerFile, setAdsBannerFile] = useState('');

    const joditConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing here...',
        height: 300,
        toolbarSticky: true,
        width: '100%',
    }), []);

    /*

    */

    const formValidation = () => {
        /*
        const newErrors = {};
        const urlPattern = /^https?:\/\/.+/;
        let firstInvalidRef = null;

        if (!formData?.title) {
            newErrors.title = "Title cannot be empty.";
            firstInvalidRef = combinedRef.current['title'];
        } else if (formData?.title?.length < 3) {
            newErrors.title = "Slider title must be at least 3 characters.";
            firstInvalidRef = combinedRef.current['title'];
        } else if (formData?.title?.length > 100) {
            newErrors.title = "Slider title must not exceed 100 characters.";
            firstInvalidRef = combinedRef.current['title'];
        }

        if (formData?.trailer_link && !urlPattern.test(formData?.trailer_link)) {
            newErrors.trailer_link = "Trailer Link must start with http:// or https://";
            if (!firstInvalidRef) firstInvalidRef = combinedRef.current['trailer_link'];
        }

        if (formDataError?.dark) {
            newErrors.dark = formDataError.dark;
            if (!firstInvalidRef) firstInvalidRef = combinedRef.current['dark'];
        }

        if (formDataError?.light) {
            newErrors.light = formDataError.light;
            if (!firstInvalidRef) firstInvalidRef = combinedRef.current['light'];
        }

        setFormDataError((prev) => ({
            ...prev,
            ...newErrors,
        }));

        if (firstInvalidRef) {
            firstInvalidRef.focus();
            return false;
        }
        */

        return true;
    };

    const handleStore = (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
        else {
            console.table("validation")
        }
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            const modelName = "Slider";
            if (name == 'icon') {
                if (lightImageFile) formDataAdd.append('player_image', lightImageFile)
                if (darkImageFile) formDataAdd.append('slider_image', darkImageFile)
                if (adsBannerFile) formDataAdd.append('ads_banner', adsBannerFile)

                formDataAdd.append("id", id);
                formDataAdd.append("modelName", modelName);
                if (lightImageFile) formDataAdd.append('imageFields[]', 'player_image')
                if (darkImageFile) formDataAdd.append('imageFields[]', 'slider_image')
                if (adsBannerFile) formDataAdd.append('imageFields[]', 'ads_banner')

                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            setDarkImageFile(null)
            setLightImageFile(null)
            setAdsBannerFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["title", "description", "link", "trailer_link", "active", "enable_gradient", "is_ads", "ads_title", "ads_description", "cta_button_name"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                if (darkImageFile || lightImageFile || adsBannerFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                navigate("/sliders")
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["title", "description", "link", "trailer_link", "active", "enable_gradient", "is_ads", "ads_title", "ads_description", "cta_button_name"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                if (darkImageFile || lightImageFile || adsBannerFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type == "text") {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: value,
            }));
        }
        setFormDataError((prevEditUser) => ({
            ...prevEditUser,
            [name]: '',
        }));
    }

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            // const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                setDarkImageFile(null);
                setLightImageFile(null);
                if (combinedRef.current?.[name]) {
                    combinedRef.current[name].focus();
                }
                return;
            }

            if (name == 'dark') {
                const isValid = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                if (!isValid) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be 3840x1440px or in 8:3 Ratio",
                    }));
                    setDarkImageFile(null);
                    if (combinedRef.current?.[name]) {
                        combinedRef.current[name].focus();
                    }
                    return;
                }
                setDarkImageFile(newFile);
            }
            if (name == 'light') {
                const isValid = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                if (!isValid) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be 3840x1440px or in 8:3 Ratio",
                    }));
                    setLightImageFile(null);
                    if (combinedRef.current?.[name]) {
                        combinedRef.current[name].focus();
                    }
                    return;
                }
                setLightImageFile(newFile);
            }
            if (name == 'ads_banner') {
                setAdsBannerFile(newFile);
            }
        }
    }

    useEffect(() => {
        if (!id && location.state?.is_ads !== undefined) {
            setFormData(prev => ({ ...prev, is_ads: location.state.is_ads }));
        }
    }, [id, location.state]);

    const handleClearSelectFile = (value) => {
        if (value == 'dark') {
            setDarkImageFile(null)
        }
        if (value == 'light') {
            setLightImageFile(null)
        }
        if (value == 'ads_banner') {
            setAdsBannerFile(null)
        }
    }

    useEffect(async () => {
        if (id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.slider,
                        }));
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }


    }, [withOutRefresh]);


    useEffect(async () => {
        await fetchRequest({
            method: 'GET',
            url: `${compressImageApi}`,
            params: {},
            data: {},
        })
            .then(response => {
                if (response?.status) {
                    setDefaultOption((prev) => ({
                        ...prev,
                        sizeOption: response?.Compress_image,
                    }))
                }
            }).catch((error => {
                toast.error(error?.response?.data?.message)
            })).finally(() => {
                setLoading(false)
            })
    }, [])

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {/* {showOverlay && <Response_Processing></Response_Processing>} */}
            <AdminBackNavigation path={`/sliders`} text="Back" />
            <AdminSaveHeader heading={(formData?.is_ads === 1 && onlyPermission?.includes(48)) ? (id ? "Edit Promotional Ad" : "Add Promotional Ad") : (id ? "Edit Slider" : "Add Slider")} saveText={(formData?.is_ads === 1 && onlyPermission?.includes(48)) ? (id ? "Update Ad" : "Add Ad") : (id ? "Update Slider" : "Add  Slider")} saveMethod={handleStore} loading={showOverlay} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        {onlyPermission?.includes(48) && (
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Promote as Advertisement"} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch name={'is_ads'} checked={formData?.is_ads == 1} onChange={handleInput} />
                                </div>
                            </div>
                        )}
                    </Wrapper>

                    {(formData?.is_ads === 1 && onlyPermission?.includes(48)) ? (
                        <Wrapper>
                            <MessageLabel text="Ads Title" className="" />
                            <AdminCustomInput type="text" name="ads_title" value={formData?.ads_title} onChange={handleInput} placeHolder={"Enter Ads Title"} error={formDataError?.ads_title} />

                            <MessageLabel text="Ads Description" className="" />
                            <div className="mb-3">
                                <JoditEditor
                                    value={formData?.ads_description || ''}
                                    config={joditConfig}
                                    onBlur={(newContent) => setFormData(prev => ({ ...prev, ads_description: newContent }))}
                                />
                            </div>

                            <MessageLabel text="CTA Button Name" className="" />
                            <AdminCustomInput type="text" name="cta_button_name" value={formData?.cta_button_name} onChange={handleInput} placeHolder={"Enter Button Name (e.g. Shop Now)"} error={formDataError?.cta_button_name} />

                            <MessageLabel text="Target Link" className="" />
                            <AdminCustomInput type="text" name="link" value={formData?.link} onChange={handleInput} placeHolder={"Enter Ads Target Link"} error={formDataError?.link} />
                        </Wrapper>
                    ) : (
                        <Wrapper>
                            <MessageLabel text="Slider Name" className="" />
                            <AdminCustomInput type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Enter Slider title"} error={formDataError?.title} />

                            <MessageLabel text="Target Link" className="" />
                            <AdminCustomInput type="text" name="link" value={formData?.link} onChange={handleInput} placeHolder={"Enter Slider Target Link"} error={formDataError?.link} />

                            <MessageLabel text="Trailer Link" className="" />
                            <AdminCustomInput type="text" name="trailer_link" value={formData?.trailer_link} onChange={handleInput} placeHolder={"Enter Slider Trailer Link"} error={formDataError?.trailer_link} />
                        </Wrapper>
                    )}

                    <Wrapper>
                        <MessageHeading text="Status Settings" />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Slider Status "} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                        {formData?.is_ads !== 1 && (
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Slider Gradient "} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch name={'enable_gradient'} checked={formData?.enable_gradient == 1} onChange={handleInput} />
                                </div>
                            </div>
                        )}
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    {(formData?.is_ads === 1 && onlyPermission?.includes(48)) ? (
                        <Wrapper>
                            <MessageHeading text='Ads Assets' />
                            <MessageLabel text="Ads Banner" />
                            <AdminImageUploadZone
                                onChange={handleFileChange}
                                selectedFile={adsBannerFile}
                                uploadedImage={formData?.ads_banner}
                                onDelete={handleClearSelectFile}
                                name="ads_banner"
                                id={id}
                                error={formDataError?.ads_banner}
                                aspect_ratio="No Ratio Validation"
                            />
                        </Wrapper>
                    ) : (
                        <Wrapper>
                            <MessageHeading text='Thumbnails' />
                            <MessageLabel text="Slider Image" />
                            <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                            <AdminImageUploadZone
                                onChange={handleFileChange}
                                selectedFile={darkImageFile}
                                uploadedImage={formData?.slider_image}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.dark = el)}
                                name="dark"
                                id={id}
                                error={formDataError?.dark}
                            />
                            <MessageLabel text="Player Image" />
                            <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                            <AdminImageUploadZone
                                onChange={handleFileChange}
                                selectedFile={lightImageFile}
                                uploadedImage={formData?.player_image}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.light = el)}
                                name="light"
                                id={id}
                                error={formDataError?.light}
                            />
                        </Wrapper>
                    )}
                </RightWrapper>
                <AdminCustomButton saveMethod={handleStore} type="submit" saveText={(formData?.is_ads === 1 && onlyPermission?.includes(48)) ? (id ? "Update Ad" : "Add Ad") : (id ? "Update Slider" : "Add Slider")} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </>
    );
}
const mapStateToProps = (state) => ({
    onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(SliderAddUpdate);